import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';

interface TitleProps {
    hrSimulation: HrSimulation;
    onDuplicateButtonClick: (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => void;
    onDeleteButtonClick: (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => void;
}

const StyTitleGrid = styled(Box, {
    name: 'StyTitleGrid',
})(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '100%',
}));

const StyDeleteIcon = styled(DeleteIcon, {
    name: 'StyDeleteIcon',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    borderRadius: '50%',
    padding: '2px',
    boxSizing: 'content-box',
    outlineStyle: 'solid',
    outlineWidth: 'thin',
}));

const StyContentCopyIcon = styled(ContentCopyIcon, {
    name: 'StyContentCopyIcon',
})(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    borderRadius: '50%',
    padding: '2px',
    boxSizing: 'content-box',
}));

const SimulationItemTitle = ({
    hrSimulation,
    onDuplicateButtonClick,
    onDeleteButtonClick,
}: TitleProps): React.ReactElement => (
    <StyTitleGrid>
        <Typography
            variant="h4"
            sx={{
                paddingTop: '0.5em',
                overflow: 'hidden',
                maxWidth: '50%',
            }}
            color="primary"
        >
            {hrSimulation.title.length < 30
                ? hrSimulation.title
                : hrSimulation.title.slice(0, 27) + '...'}
        </Typography>

        <Box sx={{ display: 'flex', height: '2em' }}>
            <IconButton onClick={onDuplicateButtonClick}>
                <StyContentCopyIcon onMouseDown={(e) => e.stopPropagation()} />
            </IconButton>
            <IconButton onClick={onDeleteButtonClick}>
                <StyDeleteIcon onMouseDown={(e) => e.stopPropagation()} />
            </IconButton>
        </Box>
    </StyTitleGrid>
);

export default SimulationItemTitle;
